import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MfaStateService } from '../services/mfa-state.service';

export const mfaGuard: CanActivateFn = () => {
  const mfaState = inject(MfaStateService);
  const router = inject(Router);

  if (mfaState.hasState()) {
    return true;
  }
  return router.createUrlTree(['/']);
};
